// src/react/flags.context.ts
import { createContext } from "react";
var FlagsContext = createContext({
  environment: "development",
  identityState: { status: "loading" },
  providerId: "flags-fallback",
  remoteEnabled: false
});
var FALLBACK_FLAGS_PROVIDER_ID = "flags-fallback";
var REMOTE_FLAGS_PROVIDER_ID = "flags-remote";

export {
  FlagsContext,
  FALLBACK_FLAGS_PROVIDER_ID,
  REMOTE_FLAGS_PROVIDER_ID
};
//# sourceMappingURL=chunk-AP3IQJFK.js.map